import ar from './ar.json';
import en from './en.json';

export const defaultLanguage = 'ar';

const languages = {
  ar,
  en,
};

export function getLanguage(code) {
  return languages[code];
}





